import React, { lazy, Suspense, useEffect } from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";
import Login from './pages/login/Login';
// import Room from './pages/room/Room';
import * as Actions from "./store/actions/index"
import SecureRouterWrapper from './SecureRouterWrapper';
import { isChrome, isFirefox, isSafari, isMobileSafari, isMobile, withOrientationChange, isEdgeChromium, isEdge, is, isAndroid, isIOS } from "react-device-detect";
import swal from 'sweetalert';
import { CustomLogger } from './store/actions/index';
import { useDevice } from './helpers/useDevice';
import { CircularProgress } from '@material-ui/core';
// import NewLogin from './pages/login/NewLogin';
// import NewRoomScreem from './pages/newRoomScreen/NewRoomScreem';
// import RedirectToEngage from './pages/redirectToEngage/RedirectToEngage';
// import AutoLogin from './pages/autoLogin/AutoLogin';
// import UnSupportedBrowserScreen from "./pages/unSupportedBrowser/unSupportedBrowserScreen.js";
// import MeetingScreen from './pages/meetingScreen/MeetingScreen';
import JoinMeeting from './pages/joinMeeting/JoinMeeting';

const allowedBrowser = isChrome || isFirefox || isSafari || isEdgeChromium || isEdge;

const NewLogin = lazy(() => import("./pages/login/NewLogin"));
const NewRoomScreem = lazy(() => import("./pages/newRoomScreen/NewRoomScreem"));
const RedirectToEngage = lazy(() => import("./pages/redirectToEngage/RedirectToEngage"));
const AutoLogin = lazy(() => import("./pages/autoLogin/AutoLogin"));
const UnSupportedBrowserScreen = lazy(() => import("./pages/unSupportedBrowser/unSupportedBrowserScreen.js"));
const MeetingScreen = lazy(() => import("./pages/meetingScreen/MeetingScreen"));
// const JoinMeeting = lazy(() => import("./pages/joinMeeting/JoinMeeting"));

const App = (props) => {
    CustomLogger("Browser Allowed", allowedBrowser)
    const dispatch = useDispatch()
    const { IsWeb, IsMob } = useDevice()

    useEffect(() => {
        dispatch(Actions.getUrl(true))
        const UserData = sessionStorage.getItem("UserData");

        UserData && dispatch(Actions.CheckingUserData(JSON.parse(UserData)))

    }, [])


    const FallBackUi = () => {
        return (
            <div style={{ height: "100vh", width: "100%" }} className="d-flex justify-content-center align-items-center">
                <CircularProgress />
            </div>

        );
    };



    return (
        <Suspense fallback={
            <FallBackUi />
        }>
            {
                allowedBrowser && !isAndroid && !isIOS ? <SecureRouterWrapper>
                    <Routes>
                        {/* <Route path="/newLogin" exact render={() => <NewLogin />} /> */}
                        <Route path="/" exact element={<NewLogin />} />
                        <Route path="/room/:id" exact element={<JoinMeeting />} />
                        <Route path="/room" exact element={<NewRoomScreem />} />
                        {/* <Route path="/roomTest" exact element={() => <Room />} /> */}
                        <Route path="/billing" exact element={<NewRoomScreem />} />
                        <Route path="/meeting" exact element={<MeetingScreen />} />
                        <Route path="/vv/access-code/:id" exact element={<RedirectToEngage />} />
                        <Route path="/autoLogin" exact element={<AutoLogin />} />
                        <Route path="*" exact element={<Navigate to="/" />} />

                    </Routes>
                </SecureRouterWrapper> :
                    <Routes>
                        {/* <Route path="/room/:id" exact element={() => <JoinMeeting />} /> */}
                        <Route path="/room/:id" exact element={<UnSupportedBrowserScreen />} />
                        <Route path="/vv/access-code/:id" exact element={<RedirectToEngage />} />
                        <Route path="/autoLogin" exact element={<AutoLogin />} />
                        <Route path="*" exact element={<UnSupportedBrowserScreen />} />
                    </Routes>
            }
        </Suspense>



    )
}

export default App
